export class ActivityArea
{
    id:number;
    active:boolean;
    code: String;
    label:String;
}